export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=58f98d88&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/materials-online-courses/index.vue?vue&type=template&id=58f98d88&
// module id = 1482
// module chunks = 0